"use client";

import React from "react";

export interface JobModalInputProps {
  label?: string;
  required?: boolean;
  type?: string;
  placeholder?: string;
  value: string;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  onBlur?: (
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  error?: string;
  hideErrorMessage?: boolean;
  multiline?: boolean;
  rows?: number;
  className?: string;
  inputClassName?: string;
  disabled?: boolean;
  name?: string;
  id?: string;
  autoComplete?: string;
  maxLength?: number;
}

export default function JobModalInput({
  label,
  required = false,
  type = "text",
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  hideErrorMessage = false,
  multiline = false,
  rows = 4,
  className = "",
  inputClassName = "",
  disabled = false,
  name,
  id,
  autoComplete,
  maxLength,
}: JobModalInputProps) {
  const baseInputClass = `w-full border rounded-lg px-3 py-2.5 text-sm focus:outline-primaryBlue transition-colors ${
    error ? "border-[#EC4D4D]" : "border-gray-300"
  } ${disabled ? "bg-gray-100 cursor-not-allowed" : "bg-white"} ${inputClassName}`;

  return (
    <div className={className}>
      {label && (
        <label
          htmlFor={id}
          className="block text-xs sm:text-sm font-semibold text-primaryBlack mb-1.5"
        >
          {label} {required && <span className="text-[#EC4D4D]">*</span>}
        </label>
      )}

      {multiline ? (
        <textarea
          id={id}
          name={name}
          rows={rows}
          placeholder={placeholder}
          disabled={disabled}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          maxLength={maxLength}
          className={`${baseInputClass} min-h-30 resize-none`}
        />
      ) : (
        <input
          id={id}
          name={name}
          type={type}
          autoComplete={autoComplete}
          placeholder={placeholder}
          disabled={disabled}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          maxLength={maxLength}
          className={baseInputClass}
        />
      )}

      {error && !hideErrorMessage && (
        <p className="text-[#EC4D4D] text-xs mt-1">{error}</p>
      )}
    </div>
  );
}
